type Point = [number, number];

interface BoundingSquare {
  x: number;
  y: number;
  size: number;
}

export const getBoundingSquare = (
  points: Point[],
  originalWidth: number,
  originalHeight: number,
  paddingFactor = 0.1
): BoundingSquare => {
  const xValues = points.map(([x]) => x * originalWidth);
  const yValues = points.map(([, y]) => y * originalHeight);
  const minX = Math.min(...xValues);
  const maxX = Math.max(...xValues);
  const minY = Math.min(...yValues);
  const maxY = Math.max(...yValues);

  const width = maxX - minX;
  const height = maxY - minY;
  const size = Math.max(width, height);
  const padding = size * paddingFactor;

  const squareSize = size + padding * 2;

  return {
    x: Math.max(0, minX - squareSize / 2 + width / 2),
    y: Math.max(0, minY - squareSize / 2 + height / 2),
    size: squareSize,
  };
};
